/**
 * UI Label Constants
 *
 * UX-007: Standardized button labels for consistency across the application.
 * All user-facing button text should reference these constants.
 */

export const BUTTON_LABELS = {
  // Primary calculation actions
  COMPARE_TARIFFS: 'Porównaj taryfy',
  CALCULATE: 'Oblicz',
  CALCULATE_COMPARISON: 'Oblicz porównanie taryf',

  // Navigation actions
  GO_TO_BASIC: 'Kalkulator szczegółowy',
  GO_TO_PRO: 'Kalkulator profesjonalny',
  GO_TO_IMPORT: 'Importuj dane',
  GO_TO_DASHBOARD: 'Panel Klienta',

  // Data source actions
  LOAD_FROM_IMPORT: 'Pobierz wzorce z danych',
  GENERATE_FROM_CSV_IMPORT: 'Oblicz na podstawie zaimportowanych danych CSV',
  GO_TO_CSV_IMPORT: 'Prześlij raport CSV z danymi zużycia',

  // Save/export actions
  SAVE_CALCULATION: 'Zapisz kalkulację',
  UPDATE_CALCULATION: 'Zaktualizuj kalkulację',
  EXPORT_CSV: 'Eksportuj do CSV',
  EXPORT_PDF: 'Eksportuj do PDF',
  SHARE_RESULTS: 'Udostępnij wyniki',

  // Secondary actions
  RESET_FORM: 'Wyczyść formularz',
  BACK: 'Wstecz',
  NEXT: 'Dalej',
  SKIP: 'Pomiń',
  CLOSE: 'Zamknij',
  CANCEL: 'Anuluj',
  CONFIRM: 'Potwierdź',
  DELETE: 'Usuń',

  // Quick actions
  MANAGE_DATA: 'Zarządzaj danymi',
  VIEW_DETAILS: 'Zobacz szczegóły',
} as const;

export const TOOLTIPS = {
  LOAD_FROM_IMPORT:
    'Załaduj godzinowe wzorce zużycia z zaimportowanych danych CSV',
  COMPARE_TARIFFS:
    'Oblicz i porównaj koszty dla wszystkich dostępnych taryf',
  SAVE_CALCULATION:
    'Zapisz bieżącą kalkulację, aby móc do niej wrócić później',
  EXPORT_CSV:
    'Pobierz wyniki w formacie CSV do dalszej analizy',
} as const;

/**
 * Helper type for button label keys
 */
export type ButtonLabelKey = keyof typeof BUTTON_LABELS;

/**
 * Helper type for tooltip keys
 */
export type TooltipKey = keyof typeof TOOLTIPS;
